import { render, staticRenderFns } from "./BookingSummary.vue?vue&type=template&id=68b4e352&lang=pug&"
import script from "./BookingSummary.vue?vue&type=script&lang=ts&"
export * from "./BookingSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports